export default __webpack_public_path__ + "static/4-societal-collapse-487f72c1e190ea5f8e660bf454f587fd.png";